// src/utilities/events.ts
var AnacapriEvent = class extends CustomEvent {
  constructor(type, eventInitDict) {
    const bubbles = eventInitDict?.bubbles !== void 0 ? eventInitDict.bubbles : false;
    const composed = eventInitDict?.composed !== void 0 ? eventInitDict.composed : false;
    const cancelable = eventInitDict?.cancelable !== void 0 ? eventInitDict.cancelable : true;
    super(type, { ...eventInitDict, bubbles, cancelable, composed });
  }
};

export {
  AnacapriEvent
};
